export * from './NotFound';


// WEBPACK FOOTER //
// ./src/components/Common/NotFound/index.ts